import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import Colors, {
  InternalColors, LightModeColors, DarkModeColors, augmentCustomColors,
} from './common/Colors';
import Font from './common/Font';
import responsiveCSSProperties from './util/responsiveCSSProperties';
import spacingNum from './util/spacingNum';
import simulateBreakpointFns from './util/simulateBreakpointFns';

export const DARK_MODE = 'dark';
export const LIGHT_MODE = 'light';

export const createMmmTheme = (options = {}) => {
  const {
    colors = 'default',
    mode = LIGHT_MODE,
    forceBreakpoint,
  } = options;
  const themeAddons = [
    responsiveFontSizes,
    responsiveCSSProperties,
    spacingNum,
    augmentCustomColors,
  ];
  const theme = createTheme({
    palette: {
      ...(colors === 'default' ? Colors : InternalColors),
      ...(mode === LIGHT_MODE ? LightModeColors : DarkModeColors),
      mode,
    },
    ...simulateBreakpointFns(forceBreakpoint),
    contrastThreshold: 3,
    // Used to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
    typography: Font,
    components: {
      MuiLink: {
        defaultProps: {
          underline: 'hover',
        },
      },
    },
  });
  return themeAddons.reduce((themeResult, addon) => addon(themeResult), theme);
};
